customError = require '@atlassian/trello-error-ext'

module.exports = customError 'PollTimeoutError'
